import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";

export default function TrackPageview() {
    const location = useLocation();
    const last = useRef("");

    useEffect(() => {
        if (location.pathname.startsWith("/admin")) return;
        if (last.current === location.pathname) return;
        last.current = location.pathname;
        const payload = { path: location.pathname };
        if (!sessionStorage.getItem("moebus_src_sent")) {
            sessionStorage.setItem("moebus_src_sent", "1");
            const params = new URLSearchParams(window.location.search);
            payload.first = true;
            payload.src = params.get("src") || params.get("source") || params.get("utm_source") || "";
            payload.ref = document.referrer || "";
        }
        axios.post(`${API}/track`, payload).catch(() => {});
    }, [location.pathname]);

    return null;
}
